import { render } from "./VPAAStaffRepUnitLoadingDialog.vue?vue&type=template&id=5d2b274a"
import script from "./VPAAStaffRepUnitLoadingDialog.vue?vue&type=script&lang=js"
export * from "./VPAAStaffRepUnitLoadingDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__